import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgCloseCircleThick } from '../icons/CloseCircleThick';

export function FailIcon(props: SvgIconProps): React.ReactElement {
  return <SvgIcon {...props} component={SvgCloseCircleThick} data-qa="FailIcon" />;
}
